import * as React from "react";
import AIInsightsContainer from "../AI-Insights/AIInsightsContainer";

const AIInsightsRoute: React.FC = () => {
  return <AIInsightsContainer />;
};

export default AIInsightsRoute;
